import variables from './variables'
import spacing from './spacing'
import color from './color'
import breakpoints from './breakpoints'

const Style = {
	spacing,
	color,
	breakpoints,
	variables,
}
export { Style }
